import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading esports content..." @subtitle="Gathering tournament updates and competitive gaming news" />
</template>
